import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, SearchService, SimpleSearchParameter } from '@un-fao/lightforms-lib/lightforms-services';

@Component({
    selector: 'related-observations',
    templateUrl: './related-observations.component.html',
    styleUrl: './related-observations.component.css',
    standalone: false
})
export class RelatedObservationsComponent implements OnInit
{  
  @Input() cssClass: string;
  @Input() title: string;
  @Input() collectionForm: any;
  @Input() inventoryId: any;
  @Input() mostRecent: boolean = false;
  @Input() currentId: string;
  @Input() lazy: boolean = false;
  
  public items: Array<any>;
  public complex: boolean = false;
  public pageReady: boolean = false;
  public loading: boolean = false;

  constructor(
    private searchService: SearchService,
    public configService: ConfigurationService
  ) {}

  ngOnInit(): void 
  {
    if (!this.lazy)
    {
      let ids;
      if (typeof(this.inventoryId) === 'object') {
        ids = this.inventoryId.map(e => { return e.value; }).join(",");
      } else {
        ids = this.inventoryId;
      }

      this.pageReady = true;
  
      //inventoryId può essere multiplo
      this.search(ids);      
    }
    else
    {
      if (typeof(this.inventoryId) !== 'object') {
        this.lazy = false;
        this.search(this.inventoryId);
      }

      this.pageReady = true;
    }    
  }

  getFactsheets(ids,item)
  {
    if (item.items) {
      item.open = !item.open;
    } else {
      this.search(ids,item);
    }
  }

  search(ids, item?: any)
  {
    if (item) {
      item.loading = true;
    } else {
      this.loading = true;
    }

    this.searchService.searchCollectionItems(
      this.collectionForm.space, 
      this.collectionForm.collection, 
      [new SimpleSearchParameter("document.inventoryId","(" + ids + ")")],
      100,0,"document.references.reportingYear:DESC",null,["id","document.title","document.references.reportingYear", "status","metadata"]).subscribe(res => 
    {
      if (this.mostRecent) {
        if (item) {
          item.open = true;
          item.items = res?.results?.values && res?.results?.values.length > 0 ? [res?.results?.values[0]] : [];
        } else {
          this.items = res?.results?.values && res?.results?.values.length > 0 ? [res?.results?.values[0]] : [];
        }
      } else {
        if (item) {
          item.open = true;
          item.items = res?.results?.values;
        } else {
          this.items = res?.results?.values;
        }
      }

      if (item) {
        item.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
}
